import { createSlice } from "@reduxjs/toolkit";
import { Branch } from "../models/response/branch";

interface BranchState {
  branches: Branch[];
}

const initialState: BranchState = {
  branches: [],
};

const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    setBranches: (state, action) => {
      state.branches = action.payload;
    },
  },
});

export const { setBranches } = branchSlice.actions;

export default branchSlice.reducer;
